module.exports = __webpack_public_path__ + "img/qidian.79ec12ae.png";